import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 60000,
  withCredentials: true,
});

export async function sendChat({ session_id, message, destination, persona, mood, culture_hint, location_hint, local_time_hint, hp }) {
  const { data } = await api.post("/chat", {
    session_id, message, destination, persona, mood,
    culture_hint, location_hint, local_time_hint, hp,
  });
  return data;
}

export async function fetchBlogs(interest) {
  const { data } = await api.get("/blogs", { params: interest ? { interest } : {} });
  return data;
}

export async function fetchBlog(id) {
  const { data } = await api.get(`/blogs/${id}`);
  return data;
}

export async function enrichLead({ session_id, field, value }) {
  const { data } = await api.post("/lead/enrich", { session_id, field, value });
  return data;
}

export async function fetchLeads() {
  const { data } = await api.get("/leads");
  return data;
}
